module.exports = __webpack_public_path__ + "static/media/siad.b6b335ff.png";